export default class Header {
  constructor(element) {
    this.element = element;
    this.html = document.documentElement;
    this.body = document.body;
    this.trigger = this.element.querySelector('#mobile-trigger');
    this.menu = this.element.querySelector('.header-center');
    this.menuListItems = this.element.querySelector('.menu-list-items');

    this.scrollThreshold = 10;

    this.init();
    this.initNavMobile();
  }
  
  init() {
    if (!this.element || !this.menuListItems) return;
    
    const handleScroll = () => {
      const scrollTop = window.scrollY || document.documentElement.scrollTop;
      const isDesktop = window.innerWidth > 1299;
      
      const targetClass = isDesktop ? "desktopfixed" : "mobiletopfixed";
      const wrongClass = isDesktop ? "mobiletopfixed" : "desktopfixed";
      
      if (scrollTop > this.scrollThreshold) {
        this.menuListItems.classList.add(targetClass);
        this.menuListItems.classList.remove(wrongClass);
      } else {
        this.menuListItems.classList.remove("desktopfixed", "mobiletopfixed");
      }
      
      if (isDesktop && this.menu.classList.contains('active')) {
        this.closeMenu();
      }
    };
    
    window.addEventListener("scroll", handleScroll, { passive: true });
    window.addEventListener("resize", handleScroll);
  }
  
  initNavMobile() {
    if (this.trigger && this.menu) {
      this.trigger.addEventListener("click", () => {
        const isActive = this.menu.classList.contains("active");
        
        if (!isActive) {
          this.openMenu();
        } else {
          this.closeMenu();
        }
      });
    }
  }
  
  openMenu() {
    this.trigger.classList.add("active");
    this.menu.classList.add("active");
    this.element.classList.add("menu-open");
    this.html.style.overflow = 'hidden';
    this.body.style.overflow = 'hidden';
  }
  
  closeMenu() {
    this.trigger.classList.remove("active");
    this.menu.classList.remove("active");
    this.element.classList.remove("menu-open");
    this.html.style.overflow = '';
    this.body.style.overflow = '';
  }
}